// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2i4Jw","additionalInfo":"AgreementModal_additionalInfo__3CgUH"};